export const validateAllFileSize = (allFileMaxSize, files = []) => {
  const allFileSizes = Array.prototype.reduce.call(files, (size, file) => (size += file.size), 0);
  return allFileSizes > allFileMaxSize * 1024 * 1024;
};
